import React, { useContext } from 'react';
import { Typography, Box } from '@mui/material';
import BtnComponent from '../buttonComponent/BtnComponent';
import { Grid, Hidden, Paper } from '@mui/material';
import { ThemeProvider } from '@mui/styles';
import { createTheme } from '@mui/system';
import CarouselWrapper from '../CarouselComponent/CarouselWrapper';
import { Link, Navigate, useLocation } from 'react-router-dom';
import OtpVerficationComponent from './OtpVerificationComponent';
import GlobalContext from '../../context/globalContext';
import { OTP_VERIFICATION } from '../../shared/Strings';

function MobileVerificationWrapper() {
  const { carousel } = useContext(GlobalContext);
  const theme = createTheme();
  const { state } = useLocation();

  if (!state) {
    return <Navigate to={'/signup'} />;
  }

  return (
    <ThemeProvider theme={theme}>
      <Grid container component="main" sx={{ height: '100vh' }}>
        <Hidden mdDown>
          <Grid item xs={false} sm={false} md={5}>
            <CarouselWrapper carouselConfig={carousel} />
          </Grid>
        </Hidden>
        <Grid
          item
          xs={12}
          md={7}
          component={Paper}
          square
          sx={{
            display: 'flex',
            justifyContent: 'center',
            background: '#f7f7f7',
          }}>
          <Box
            sx={{
              position: 'absolute',
              right: 0,
              m: 1,
              display: 'flex',
              justifyContent: 'flex-end',
              flexDirection: 'row',
              alignItems: 'center',
            }}>
            <Typography marginRight={1}>
              {OTP_VERIFICATION.HAVE_ACCOUNT}
            </Typography>
            <BtnComponent
              component={Link}
              to={'/login'}
              size="small"
              title={OTP_VERIFICATION.LOGIN}></BtnComponent>
          </Box>
          <Box
            sx={{
              my: 7,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'left',
              overflow: 'hidden',
              minWidth: { xs: '80vw', sm: '60vw', md: '35vw' },
            }}>
            <OtpVerficationComponent
              phoneNumber={state.phoneNumber}
              userId={state.userId}
            />
          </Box>
        </Grid>
      </Grid>
    </ThemeProvider>
  );
}

export default MobileVerificationWrapper;
